import React from 'react';
export function Header() {
  return <header className="w-full bg-white shadow-sm sticky top-0 z-50" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-17">
        <div className="flex items-center justify-between" data-id="element-18">
          <img src="https://cdn.magicpatterns.com/uploads/tChUg5UqoxyR6EhQyRn7LZ/Logo_Jazugas.png" alt="JAZUGAS - Ingeniería Electromecánica" className="h-12 md:h-16 w-auto" data-id="element-19" />
          <a href="https://wa.me/50689925929" target="_blank" rel="noopener noreferrer" className="text-jazugas-blue hover:text-jazugas-gold font-semibold transition-colors" data-id="element-20">
            WhatsApp: 8992-5929
          </a>
        </div>
      </div>
    </header>;
}